import React from 'react';
import { Instagram, Phone, Mail } from 'lucide-react';
export function Footer() {
  return <footer id="kontakt" className="bg-black pt-16 sm:pt-24 pb-8 sm:pb-12 px-4 sm:px-6 lg:px-8" data-id="element-36">
      <div className="mx-auto max-w-7xl" data-id="element-37">
        {/* Section Header */}
        <div className="mb-10 sm:mb-16 text-center" data-id="element-38">
          <h2 className="text-2xl sm:text-3xl font-light text-white sm:text-4xl" data-id="element-39">
            Stopite v{' '}
            <span className="font-serif italic text-neutral-400" data-id="element-40">stik</span>
          </h2>
          <div className="mt-4 h-px w-24 bg-neutral-800 mx-auto" data-id="element-41"></div>
        </div>

        {/* Contact Cards */}
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 sm:gap-6 mb-12 sm:mb-20" data-id="element-42">
          {/* Instagram */}
          <a href="https://www.instagram.com/dreambigslo/" target="_blank" rel="noopener noreferrer" className="group flex flex-col items-center p-6 sm:p-8 border border-neutral-800 bg-neutral-950 hover:bg-neutral-900 hover:border-neutral-700 transition-all duration-300" data-id="element-43">
            <div className="mb-3 sm:mb-4 flex h-12 w-12 sm:h-14 sm:w-14 items-center justify-center rounded-full border border-neutral-700 bg-neutral-800 group-hover:border-white group-hover:bg-white transition-all duration-300" data-id="element-44">
              <Instagram className="h-5 w-5 sm:h-6 sm:w-6 text-white group-hover:text-black transition-colors duration-300" data-id="element-45" />
            </div>
            <span className="text-[10px] sm:text-xs font-medium uppercase tracking-widest text-neutral-500 mb-1 sm:mb-2" data-id="element-46">
              Instagram
            </span>
            <span className="text-base sm:text-lg text-white font-light" data-id="element-47">
              @dreambigslo
            </span>
          </a>

          {/* Phone */}
          <a href="tel:+38651247570" className="group flex flex-col items-center p-6 sm:p-8 border border-neutral-800 bg-neutral-950 hover:bg-neutral-900 hover:border-neutral-700 transition-all duration-300" data-id="element-48">
            <div className="mb-3 sm:mb-4 flex h-12 w-12 sm:h-14 sm:w-14 items-center justify-center rounded-full border border-neutral-700 bg-neutral-800 group-hover:border-white group-hover:bg-white transition-all duration-300" data-id="element-49">
              <Phone className="h-5 w-5 sm:h-6 sm:w-6 text-white group-hover:text-black transition-colors duration-300" data-id="element-50" />
            </div>
            <span className="text-[10px] sm:text-xs font-medium uppercase tracking-widest text-neutral-500 mb-1 sm:mb-2" data-id="element-51">
              Telefon
            </span>
            <span className="text-base sm:text-lg text-white font-light" data-id="element-52">
              051 247 570
            </span>
          </a>

          {/* Email */}
          <a href="mailto:info@dreambig.si" className="group flex flex-col items-center p-6 sm:p-8 border border-neutral-800 bg-neutral-950 hover:bg-neutral-900 hover:border-neutral-700 transition-all duration-300" data-id="element-53">
            <div className="mb-3 sm:mb-4 flex h-12 w-12 sm:h-14 sm:w-14 items-center justify-center rounded-full border border-neutral-700 bg-neutral-800 group-hover:border-white group-hover:bg-white transition-all duration-300" data-id="element-54">
              <Mail className="h-5 w-5 sm:h-6 sm:w-6 text-white group-hover:text-black transition-colors duration-300" data-id="element-55" />
            </div>
            <span className="text-[10px] sm:text-xs font-medium uppercase tracking-widest text-neutral-500 mb-1 sm:mb-2" data-id="element-56">
              E-pošta
            </span>
            <span className="text-base sm:text-lg text-white font-light" data-id="element-57">
              info@dreambig.si
            </span>
          </a>
        </div>

        {/* Copyright */}
        <div className="text-center pt-6 sm:pt-8 border-t border-neutral-900" data-id="element-58">
          <p className="text-xs sm:text-sm text-neutral-500" data-id="element-59">
            &copy; {new Date().getFullYear()} DREAMBIG Photography. Vse pravice
            pridržane.
          </p>
        </div>
      </div>
    </footer>;
}